import React, {FC} from "react"
import {WellnessMedia} from "@irati/types"

import VideoPlayer from "../VideoPlayer"
import PremiumPlaceholder from "./PremiumPlaceholder"

interface Props {
  media: WellnessMedia
  isMediaRented: boolean
}

const PremiumVideoPlayer: FC<Props> = ({media, isMediaRented}) =>
  isMediaRented ? <VideoPlayer media={media} /> : <PremiumPlaceholder media={media} />

export default PremiumVideoPlayer
